import Logo from 'ui/assets/syflogo.svg'
import styled from 'styled-components'
import { mediaQueries } from 'theme'

export const HeaderContainer = styled.header`
  height: 50px;
  color: white;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  background-color: #343642;
  align-items: center;
  @media ${mediaQueries.lessThanSmall} {
    height: unset;
  }
`

export const LogoImg = styled.img.attrs({
  src: Logo
})`
  height: 36px;
  margin-left: 24px;
  @media ${mediaQueries.lessThanSmall} {
    margin-right: 10px;
    margin-left: 5px;
    height: 16px;
  }
`

export const HeaderText = styled.h1`
  margin: 0px 20px;
  font-size: 28px;
  text-align: center;
  @media ${mediaQueries.lessThanLarge} {
    font-size: 18px;
    margin-right: 20px;
    margin-left: 20px;
  }
  @media ${mediaQueries.lessThanSmall} {
    font-size: 12px;
    margin-left: 5px;
    margin-right: 5px;
  }
`
